import React from 'react';
import { Hidden } from '@material-ui/core';
import Tooltip from '@cpg-its/ads.common.tooltip';
import { NewHireProps } from '../../../../models/arc-epi-props';
import { DisplayLabels } from '../models/coverage-models';
import { tcsmColors } from '../../../../../../global/constants/theme/theme-constants/colors';


interface Props {
	settings: NewHireProps;
	labels: DisplayLabels;
}

export function DeskTopVolumeRateLabel(props: Props) {
	const handleSelectComponent = (labels: DisplayLabels, settings: NewHireProps) => {

		switch (labels) {
			case 'VOLUMERATE':
				return (
					<>
						<div className='coverage-table-row-cell tier-cell'> <h5>{settings?.volumeLabel}</h5></div>
						<div className='coverage-table-row-cell tier-cell'>
							<div className='coverage-table-row-cell-tooltip'><h5>{settings?.rateLabel}</h5><div className='coverage-table-row-cell-tooltip-inner'><Tooltip iconColor={tcsmColors.white} title={settings?.rateHelper} /></div></div></div>
					</>
				);

			case 'RATE':
				return (
					<>
						<div className='coverage-table-row-cell tier-cell'> <h5>{settings?.rateLabel}</h5></div>
					</>
				);

			case 'VOLUME':
				return (
					<>
						<div className='coverage-table-row-cell tier-cell'> <h5>{settings?.volumeLabel}</h5></div>
					</>
				);

			default:
				return (
					<>
						<div className='coverage-table-row-cell tier-cell'> <h5>{settings?.volumeLabel}</h5></div>
						<div className='coverage-table-row-cell tier-cell'> <h5>{settings?.rateLabel}</h5></div>
					</>
				);
				break;
		}

	};

	const { settings, labels } = props;

	return (
		<Hidden xsDown>
			{handleSelectComponent(labels, settings)}
		</Hidden>
	);
}


